import React from "react";
import image_one from "../../assets/image_one.svg";
import image_two from "../../assets/image_two.svg";
import image_three from "../../assets/image_three.svg";
import image_four from "../../assets/image_four.svg";
import image_five from "../../assets/image_five.svg";
import image_six from "../../assets/image_six.svg";

const AdvantageData = [
  {
    img: image_one,
    heading: "Expertise at Scale",
    para: "Modernised, simplified and optimised for more than 700 clients.",
  },
  {
    img: image_two,
    heading: "Strong Industry Focus",
    para: "Industry-specific expertise across government, defence, education, manufacturing, utilities and financial services",
  },
  {
    img: image_three,
    heading: "Unique Approach",
    para: "Quick-to-market, with our IP solutions and cross-functional capabilities..",
  },
  {
    img: image_four,
    heading: "Proudly Australian",
    para: "100% Australian with offices across the nation.",
  },
  {
    img: image_five,
    heading: "Over 250 Security-Cleared Staff",
    para: "One of the largest consulting teams working with Defence and Federal Government...",
  },
  {
    img: image_six,
    heading: "Strong Technology Partnerships",
    para: "We partner with leading technology companies to offer specialised technology and scalable, expert solutions.",
  },
];

const Advantage = () => {
  return (
    <div className="flex flex-col  my-[50px] px-4 md:px-0 gap-10 items-center justify-center w-full md:w-[85%] mx-auto">
      <h1 className="text-[#451644] dark:text-light font-extrabold text-[50px] font-serif">
        The Gogi<span className="text-[#15A5E7]">Bus</span> Advantage
      </h1>

      <p className="text-sm dark:text-light sm:text-lg font-bold text-center w-full lg:w-[70%]">
        We bring specialised experience and strategic partnerships– offering
        assured leadership at critical moments requiring transformational
        change.
      </p>

      <div className="grid mt-10  grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5">
        {AdvantageData.map((advantage, index) => (
          <div
            key={index}
            className="flex min-h-[340px] flex-col items-center  justify-start gap-3"
          >
            <img src={advantage.img} className="w-24 h-24" alt="" />
            <h3 className="text-[36px] dark:text-light text-center text-[#451644] font-bold font-sans">
              {advantage.heading}
            </h3>
            <p className="text-sm dark:text-light font-light text-center ">{advantage.para}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Advantage;
